import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ShowMoreText from "react-show-more-text";

const useStyles = makeStyles((theme) => ({
      '@global': {
        '.titleWrapper': {
          position: 'relative',
        },
        '.IncCta2': {
          height: 'auto',
          '& .expandAnchor': {
            margin: '2rem 0',
            fontSize: 20,
            display: 'block',
            textDecoration: 'underline',
            color: 'white',
          }
        },
        '.IncCtaTxt2': {
          padding: '1.5rem .25rem .5rem',
          position: 'relative',
          color: 'white',
        },
        '.IncCtaLbl2': {
          fontSize: 24,
          lineHeight: '29px',
          paddingLeft: '4rem',
        },
        '.IncCtaBtn2': {
          marginTop: 'auto',
        },
        '.IncCtaId2': {
          position: 'absolute',
          left: 0,
          top: 0,
          width: '4rem',
          height: '3.8rem',
          backgroundColor: theme.palette.success.main,

          "& span": {
            fontSize: '1.5rem',
            fontWeight: 700,
            display: 'inline-block',
            [theme.breakpoints.up("md")]: {
              fontSize: '2.5rem',
            },
          },
        },
        '.content-css': {
          fontSize: '18px',
        }
      }
    })
);

export default function CustomMuiExpandCTA(props) {
  const classes = useStyles(props);
  const {children, number, title, body} = props;

  return (
      <Box className={`IncCta2`}>
        {title?.length > 0 &&
        <Box className={`titleWrapper`} p={2} bgcolor="grey.700"
             color="grey.700">
          <Typography className={`IncCtaLbl2`} component="h6" variant="h6">
            <strong dangerouslySetInnerHTML={{__html: title}}></strong>
          </Typography>
          {(number && number > -1) &&
          <Box align="center" className={`IncCtaId2`}>
            <span>{number}</span>
          </Box>
          }
        </Box>
        }
        <Box bgcolor="grey.700" px={2} color="white">
          <Box align="center" className={`IncCtaTxt2`}>

            {(body?.length > 0 || children) &&
            <Typography component={`div`}>
              <ShowMoreText
                  lines={5}
                  more="EXPAND +"
                  less="COLLAPSE -"
                  className="content-css"
                  anchorClass="expandAnchor"
                  expanded={false}
                  truncatedEndingComponent={"... "}
              >
                <div className={`inner-content`}>
                  {(body?.length > 0) &&
                  <Box
                      dangerouslySetInnerHTML={{__html: `<div class="inner-html">${body}</div>`}}/>
                  }
                  {(typeof children === 'string' || children instanceof String) &&
                  <div dangerouslySetInnerHTML={{__html: children}}/>
                  }
                  {(typeof children !== 'string') &&
                  children
                  }
                </div>
              </ShowMoreText>
            </Typography>
            }
          </Box>
        </Box>
        <Box className={`IncCtaBtn2`}></Box>
      </Box>
  );
};
